<template>
    <AuthenticatedLayout>

        <!--        <ConfirmDialog></ConfirmDialog>-->
        <ConfirmPopup></ConfirmPopup>
        <Toast position="top-center" />

        <div class="flex flex-row w-full align-items-center justify-content-between mb-4 mt-4">
            <div class="flex flex-row align-items-center">
                <div class="mr-2"><img :src="exchange.logo_url"  :alt="exchange.name"/></div>
                <div class="text-4xl mr-3">{{pair.ccxt_symbol}}</div>
                <div class="mr-4">
                    <a class="text-gray-400" :href="tradingViewUrl" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
                </div>
            </div>
        </div>

        <div class="mb-4 flex">

            <div class="mr-4">
                <Card>
                    <template #content>
                        <Candles
                            :candles="candles"
                            :title="pair.ccxt_symbol"
                            :width="maxWidth"
                            :height="500"
                            :timezone="0"
                            :zeroPrice="currentPrice"
                        />
                    </template>
                </Card>
            </div>

        </div>

        <div class="flex">
            <div class="flex-1">
                <Card class="mb-4">
                    <template #title>
                        Левая панель
                    </template>
                    <template #content>

                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Правая панель
                    </template>
                    <template #content>

                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";
import Candles from "@/Charts/Candles.vue";
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputNumber from 'primevue/inputnumber';
import ClosedDealsTable from "@/Tables/ClosedDealsTable";
import LogsTable from "@/Tables/LogsTable";
import OpenDealsTable from "@/Tables/OpenDealsTable";
import SplitButton from 'primevue/splitbutton';
import Dropdown from 'primevue/dropdown';
import SelectButton from 'primevue/selectbutton';
import InputSwitch from 'primevue/inputswitch';
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";
import Divider from "primevue/divider";
import DemoBotWarning from "@/Components/DemoBotWarning.vue";
import InlineMessage from "primevue/inlinemessage";
import HllBotSettings from "@/Settings/HllBotSettings.vue";
import TrendIndicatorSettings from "@/Settings/TrendIndicatorSettings.vue";
import BandIndicatorSettings from "@/Settings/BandIndicatorSettings.vue";
import DontSellLongSettings from "@/Settings/DontSellLongSettings.vue";
import MiddletrendSettings from "@/Settings/MiddletrendSettings.vue";
import CandlesDealsHll from "@/Charts/CandlesDealsHll.vue";
import HllIndicatorSettings from "@/Settings/HllIndicatorSettings.vue";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from 'primevue/confirmpopup';

export default {
    props: {
        pair: Object,
        exchange: Object,
        timeframe: String,
        tradingViewUrl: String,
        candles: Array,
        currentPrice: String,
    },
    components:{
        ConfirmPopup,
        ConfirmDialog,
        HllIndicatorSettings,
        CandlesDealsHll,
        MiddletrendSettings,
        DontSellLongSettings,
        BandIndicatorSettings,
        TrendIndicatorSettings,
        HllBotSettings,
        DemoBotWarning,
        PairsTwoTableSelector,
        OpenDealsTable,
        Candles,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link, Toast, ProgressSpinner, TabView, TabPanel, SpinnerWrapper,
        InputNumber,
        ClosedDealsTable, LogsTable, SplitButton, Dropdown, SelectButton, InputSwitch, Divider, InlineMessage
    },
    data(){
        return {

        }
    },
    mounted() {

    },
    watch:{

    },
    computed: {
        maxWidth(){
            return window.innerWidth - 100;
        }
    },
    methods:{
        ...helperMethods,

    }
}
</script>

